import { TextField } from '@mui/material';

import MyDialog from "~/mui/MyDialog";
import { checkForErrorsState } from '~/utils/utils';
import { useTrans } from '~/hooks/useTrans';
import { apiUpdateProject } from '~/providers/api';
import { IClientProject, IClientUpdateProject } from '~/providers/client-interfaces';
import { IUrlParams } from "~/interfaces";
import { myUseState } from "~/hooks/myUseState";
import { IAdminProject } from "~/providers/admin-interfaces";
import { useLang } from "~/hooks/useLang";
import { MAX_USER_DESCIPTION_LEN } from "~/const";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
	wasChanged: boolean;
}

// chyby formulare
type TStateErrors = {[key in keyof Pick<IClientUpdateProject, "userTitle" | "userDescription">]: string; };

interface IClientProjectNamesModal {
	params: IUrlParams;
	isInternal: boolean;
	projectData: IClientProject | IAdminProject;
	onSave?: (project: IClientProject | IAdminProject) => void;
	onClose?: () => void;
	onChange?: (isChanged: boolean) => void;
}

export default function ClientProjectNamesModal({
	params = null,
	isInternal = false,
	projectData = null,
	onSave = () => {},
	onClose = () => {},
	onChange = () => {},
}: IClientProjectNamesModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
		wasChanged: false,
	});
	const { state: stateProject, updateState: updateStateProject } = myUseState<IClientUpdateProject>({
		userTitle: projectData.userTitle,
		userDescription: projectData.userDescription,
		userSwitch: projectData.userSwitch,
		lastUpdate: projectData.lastUpdate,
	});
	const { state: stateError, setState: setStateError } = myUseState<TStateErrors>({
		userTitle: "",
		userDescription: "",
	});

	function getWasChanged(newState: Partial<IClientUpdateProject>): boolean {
		const newStateObj = {
			...stateProject,
			...newState,
		};

		if (
			newStateObj.userTitle !== projectData.userTitle
			|| newStateObj.userDescription !== projectData.userDescription
		) {
			return true;
		}

		return false;
	}

	function updateStateProjectWithChange(newState: Partial<IClientUpdateProject>) {
		const wasChanged = getWasChanged(newState);

		updateStateProject(newState);
		updateState({
			wasChanged,
		});
		onChange(wasChanged);
	}

	async function dialogOnSave() {
		const errorData = checkForErrorsState<IClientUpdateProject, TStateErrors>(stateProject, {
			userTitle: { check: "string-2-35", msg: trans("createProject.error.userTitle") },
			userDescription: { check: "string-user-desc", msg: trans("createProject.error.userDescriptionCount", { count: MAX_USER_DESCIPTION_LEN }) },
		});

		setStateError(errorData.errorsState);

		// jsou tam chyby
		if (errorData.errorsCount > 0) {
			return;
		}

		updateState({
			dialogLoading: true,
			errorMsg: "",
		});


		const outputData = await apiUpdateProject(isInternal ? "admin" : "client", params.projectId, stateProject, lang);

		if (outputData.noErrors) {
			onSave(outputData.data);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("projectSettingsModal.title")} onClose={onClose} onSave={dialogOnSave} className="projectSettings" dialogLoading={state.dialogLoading} disableSave={!state.wasChanged} errorMsg={state.errorMsg}
		confirmClose={state.wasChanged}>
		<TextField
			label={trans("projectSettingsPage.nameProject")}
			value={stateProject.userTitle}
			style={{ width: "100%" }}
			onChange={event => updateStateProjectWithChange({ userTitle: event.target.value })}
			color="success"
			autoComplete="off"
			error={stateError.userTitle !== ""}
			helperText={stateError.userTitle}
			sx={{ marginBottom: "var(--margin-large)" }}
			size="small"
		/>
		<TextField
			label={trans("projectSettingsPage.desc")}
			value={stateProject.userDescription}
			style={{ width: "100%" }}
			multiline={true}
			onChange={event => updateStateProjectWithChange({ userDescription: event.target.value })}
			color="success"
			autoComplete="off"
			rows={3}
			sx={{ marginBottom: "var(--margin-large)" }}
			error={stateError.userDescription !== ""}
			helperText={stateError.userDescription}
		/>
	</MyDialog>;
}
